(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.UserService = (function(superClass) {
    extend(UserService, superClass);

    function UserService(http, window) {
      this.http = http;
      this.window = window;
      this.phoneNumberConfirmed = bind(this.phoneNumberConfirmed, this);
      this.updateUnconfirmedNumber = bind(this.updateUnconfirmedNumber, this);
      this.viewPrivacyPolicy = bind(this.viewPrivacyPolicy, this);
      this.setLocale = bind(this.setLocale, this);
      this.saveContact = bind(this.saveContact, this);
      this.saveBackground = bind(this.saveBackground, this);
      this.getLocales = bind(this.getLocales, this);
      this.getStates = bind(this.getStates, this);
      this.getBackgroundOptions = bind(this.getBackgroundOptions, this);
      this.getSafelinkUser = bind(this.getSafelinkUser, this);
      this.getLoggedInUser = bind(this.getLoggedInUser, this);
      return;
    }

    UserService.prototype.getLoggedInUser = function() {
      return this.http.post('backend/username-dropdown/get-logged-in-user').then((function(_this) {
        return function(jsr) {
          return _this.handleJsonResponse(jsr);
        };
      })(this));
    };

    UserService.prototype.getSafelinkUser = function() {
      return this.http.post('backend/username-dropdown/get-safe-link-user').then((function(_this) {
        return function(jsr) {
          return _this.handleJsonResponse(jsr);
        };
      })(this));
    };

    UserService.prototype.getBackgroundOptions = function() {
      return this.http.post('backend/username-dropdown/get-background-options').then((function(_this) {
        return function(jsr) {
          return _this.handleJsonResponse(jsr);
        };
      })(this));
    };

    UserService.prototype.getStates = function() {
      return this.http.post('backend/username-dropdown/get-states').then((function(_this) {
        return function(jsr) {
          return _this.handleJsonResponse(jsr);
        };
      })(this));
    };

    UserService.prototype.getLocales = function() {
      return this.http.post('backend/username-dropdown/get-locales').then((function(_this) {
        return function(jsr) {
          return _this.handleJsonResponse(jsr);
        };
      })(this));
    };

    UserService.prototype.saveBackground = function(user) {
      return this.http.post('backend/username-dropdown/save-background', {
        title: user.title,
        expertise_ids: user.expertise_ids,
        professions_id: user.professions_id,
        experience: user.experience
      });
    };

    UserService.prototype.saveContact = function(pretend, user, additionalValidation) {
      if (additionalValidation == null) {
        additionalValidation = false;
      }
      return this.http.post('backend/username-dropdown/save-contact', {
        pretend: pretend,
        user: user,
        additionalValidation: additionalValidation
      });
    };

    UserService.prototype.setLocale = function(locale_id) {
      return this.http.post('backend/username-dropdown/set-locale', {
        locale_id: locale_id
      });
    };

    UserService.prototype.viewPrivacyPolicy = function() {
      this.window.open('backend/username-dropdown/privacy-policy', '_blank');
      return true;
    };

    UserService.prototype.updateUnconfirmedNumber = function(phone) {
      return this.http.post('backend/grower/sms-confirmation/update-unconfirmed-number', {
        phone: phone
      });
    };

    UserService.prototype.phoneNumberConfirmed = function() {
      return this.http.get('backend/grower/sms-confirmation/phone-number-confirmed');
    };

    return UserService;

  })(Service);

}).call(this);
